import {
  html,
  type ReactiveController,
  type ReactiveControllerHost,
  type TemplateResult,
} from "lit";
import { OPTIONS, type FeedbackWidgetValue, type Option } from "../types";

interface FeedbackTypeChoiceCallbacks {
  onChoose: (value: FeedbackWidgetValue) => void;
}

export class FeedbackTypeChoiceController implements ReactiveController {
  constructor(
    host: ReactiveControllerHost & HTMLElement,
    private callbacks: FeedbackTypeChoiceCallbacks
  ) {
    host.addController(this);
  }

  private _renderOption(opt: Option): TemplateResult {
    return html`
      <button
        type="button"
        class="eko-feedback-widget__option"
        @click=${() => this.callbacks.onChoose(opt.value)}>
        <div class="eko-feedback-widget__option-content">
          <eko-featured-icon
            size="sm"
            variant="square-light"
            theme="accent"
            icon=${opt.icon}></eko-featured-icon>
          <div class="eko-feedback-widget__option-text">
            <span class="eko-feedback-widget__option-label">${opt.label}</span>
            <span class="eko-feedback-widget__option-description">${opt.description}</span>
          </div>
        </div>
      </button>
    `;
  }

  hostConnected() {}

  render(params: { heading: string; icon: string; supportingText: string }): TemplateResult {
    const { heading, icon, supportingText } = params;
    return html`
      <eko-featured-icon
        slot="icon"
        variant="square-modern"
        theme="neutral"
        icon=${icon}></eko-featured-icon>
      <span slot="title" class="eko-feedback-widget__title">${heading}</span>
      <span slot="subtitle">${supportingText}</span>

      <div class="eko-feedback-widget__options">
        ${OPTIONS.map((opt) => this._renderOption(opt))}
      </div>
    `;
  }
}
